import { EAppTemplateType } from "templates-common-library/baseClasses/CompatibilityChecker";
import { PublishMode, PublishUI } from "../widgets/PublishForm/PublishForm";
import { AnswerInfo, QuestionInfo } from "../widgets/Sidebar/Sidebar";

const CATEGORY: string = "Instant Apps Gallery";

export function logCapabilitySearch(
  telemetry: any,
  selectionValue: string,
  currentTab: string,
  currentCapabilityCount: number
) {
  telemetry.logEvent({
    category: CATEGORY,
    action: "Capability Search Selection",
    label: selectionValue,
    attribute: currentTab,
    details: currentCapabilityCount,
  });
}

export function logInstantAppPublish(
  telemetry: any,
  currentTab: string,
  templateTypeUrl: string,
  publishMode: PublishMode,
  publishUI: PublishUI
) {
  telemetry.logEvent({
    category: CATEGORY,
    action: `Publish - ${currentTab}`,
    label: templateTypeUrl,
    details: publishMode,
    attribute: publishUI === "modal" ? "Create Modal" : "Preview Modal",
  });
}

/**
 * Log when a selection occurs in the Suggestions Q/A form
 */
export function logSuggestionAnswerEvent(
  telemetry: any,
  depth: number,
  question: QuestionInfo,
  answer: AnswerInfo
) {
  telemetry.logEvent({
    category: CATEGORY,
    action: `Suggestions Selection Event`,
    label: depth,
    details: question.questionText,
    attribute: answer.answerText,
  });
}

/**
 * Log when user provides feedback on Suggestions
 */
export function logSuggestionFeedbackEvent(
  telemetry: any,
  rating: number,
  feedbackText: string
) {
  telemetry.logEvent({
    category: CATEGORY,
    action: `Suggestions Feedback Event`,
    label: rating,
    details: feedbackText,
    attribute: "",
  });
}
